import { useContext } from 'react'
import { AuthContext, AuthContextType } from '@/presentation/providers/AuthProvider'
import { User } from '@/core/domain/entities/User'

export const useAuth = (): AuthContextType => {
  const context = useContext(AuthContext)
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider')
  }
  return context
}

// Hook to get current user data
export const useUser = (): User | null => {
  const { user } = useAuth()
  return user
}

// Hook to check authentication status
export const useIsAuthenticated = (): boolean => {
  const { isAuthenticated } = useAuth()
  return isAuthenticated
}

// Hook for theme management
export const useTheme = () => {
  const { theme, setTheme } = useAuth()
  return { theme, setTheme }
}

// Hook for language management
export const useLanguage = () => {
  const { language, setLanguage } = useAuth()
  return { language, setLanguage }
}